import Component from './component';

Component.defaultProps = {
    altText: null,
    width: null,
    height: null,
};
export default Component;